var app = angular.module('leonardo');

var FieldSelector = function(FieldSubgroupService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      label: '=',
      required: '=ngRequired'
    },
    templateUrl: 'views/templates/widget/field-selector.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.emptyGroup = {id: 0, name: 'Other'};

      FieldSubgroupService.getAll().then(function(data) {
        scope.allSubgroups = data;
        scope.groups = [];
        scope.subgroups = [];

        angular.forEach(scope.allSubgroups, function(value) {
          scope.groups[value.group ? value.group.id : 0] = value.group ? value.group : scope.emptyGroup;

          if (scope.group) {
            if (value.group && value.group.id == scope.group && value.fields.length) {
              scope.subgroups.push(value);
            }
            if (value.group === null && scope.group == 0 && value.fields.length) {
              scope.subgroups.push(value);
            }
            if (scope.subgroup && scope.subgroup == value.id) {
              scope.fields = value.fields;
            }
          }
        });
      });

      scope.onGroupChange = function() {
        scope.subgroups = [];
        scope.fields = [];
        scope.subgroup = null;
        scope.field = null;
        angular.forEach(scope.allSubgroups, function(value){
          if (value.group && value.group.id == scope.group && value.fields.length) {
            scope.subgroups.push(value);
          }
          if (value.group === null && scope.group == 0 && value.fields.length) {
            scope.subgroups.push(value);
          }
        });
      };

      scope.onSubgroupChange = function() {
        scope.fields = [];
        angular.forEach(scope.subgroups, function(value){
          if (value.id == scope.subgroup) {
           scope.fields = value.fields;
           return;
          }
        });
      };

      scope.onFieldChange = function() {
        scope.ngModelCtrl.$setViewValue({
          group: scope.group,
          subgroup: scope.subgroup,
          field: scope.field
        });
        scope.label = '';
        angular.forEach(scope.groups, function(value){
          if (value.id == scope.group) {
            scope.label += value.name + ' > ';
          }
        });
        angular.forEach(scope.subgroups, function(value){
          if (value.id == scope.subgroup) {
            scope.label += value.name + ' > ';
          }
        });
        angular.forEach(scope.fields, function(value){
          if (value.key == scope.field) {
            scope.label += value.name + ':';
            return;
          }
        });

      };

      scope.ngModelCtrl.$render = function() {
        if (scope.ngModelCtrl.$modelValue) {
          scope.group = scope.ngModelCtrl.$modelValue.group;
          scope.subgroup = scope.ngModelCtrl.$modelValue.subgroup;
          scope.field = scope.ngModelCtrl.$modelValue.field;
        }
      };

      scope.ngModelCtrl.$validators.required = function() {
        return !!scope.field;
      };
    }
  };
};

app.directive('fieldSelector', ['FieldSubgroupService', FieldSelector]);
